import React from 'react'
import { Typography } from '@mui/material'
import { Column } from 'src/components/Layout/Styled'
import ProgressBar from './ProgressBar'

const Header = () => {
  return (
    <Column sx={{ mt: { lg: '60px', xs: '24px' } }}>
      <Typography sx={{ typography: { sm: 'h4', xs: 'h5' } }}>
        สมัครสอบ E-Examination
      </Typography>
      <ProgressBar />
    </Column>
  )
}

export default Header
